'use client'
import React from 'react'
import styles from './styles.module.scss'

interface RoundCloseIconProps {
  onClickHandler?: () => void
  isMobileSearch?: boolean
}

const RoundCloseIcon: React.FC<RoundCloseIconProps> = ({
  onClickHandler,
  isMobileSearch,
}) => (
  <button
    className={`${isMobileSearch ? styles.mobileSearchButton : styles.button}`}
    onClick={onClickHandler}
  >
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.15827 1.15168C0.757141 1.54662 0.757141 2.18696 1.15827 2.5819L4.62815 5.99833L1.15827 9.41475C0.757141 9.8097 0.757141 10.45 1.15827 10.845C1.55939 11.2399 2.20974 11.2399 2.61087 10.845L6.08075 7.42855L9.38969 10.6865C9.79081 11.0814 10.4412 11.0814 10.8423 10.6865C11.2434 10.2916 11.2434 9.65122 10.8423 9.25628L7.53336 5.99833L10.8423 2.74037C11.2434 2.34543 11.2434 1.70509 10.8423 1.31015C10.4412 0.915203 9.79081 0.915204 9.38969 1.31015L6.08075 4.5681L2.61087 1.15168C2.20974 0.756732 1.55939 0.756732 1.15827 1.15168Z"
        fill="#AFB7C6"
      ></path>
    </svg>
  </button>
)

export default React.memo(RoundCloseIcon)
